import PropTypes from "prop-types";

import SessionLoadingScreen from "components/SessionLoadingScreen";
import { useAuth } from "context/AuthContext";

function AppGate({ children }) {
  const { loading } = useAuth();

  if (loading) {
    return <SessionLoadingScreen />;
  }

  return children;
}

AppGate.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppGate;
